const NAMESPACE = "SearchFilter";

const KEYS = {
    resetFiltersText: "resetFiltersText"
};

const MESSAGES = {
    [KEYS.resetFiltersText]: {
        value: "Clear Filters",
        comment: "Clear filters button text"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
